import React from 'react';
export const IndustrySecret = () => {
  return <section className="mb-12 bg-blue-50 p-6 rounded-lg" data-id="element-138">
      <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-139">
        The Billion-Pound Secret They Don't Want You to Know
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-140">
        Here's what Dr. Grant discovered that changed everything:
      </p>
      <p className="text-gray-700 mb-6 font-semibold" data-id="element-141">
        The anti-aging industry makes £43.9 billion annually by treating aging
        symptoms... while completely ignoring a primary cause of premature
        facial aging.
      </p>
      <div className="flex flex-col md:flex-row gap-8" data-id="element-142">
        <div className="md:w-1/2" data-id="element-143">
          <p className="text-gray-700 mb-4" data-id="element-144">
            Think about it. When you visit your dermatologist for wrinkles, what
            do they recommend?
          </p>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-6" data-id="element-145">
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2" data-id="element-146">
              <li data-id="element-147">Botox injections: £225-£450 every 3-4 months</li>
              <li data-id="element-148">Dermal fillers: £450-£1,125 per session</li>
              <li data-id="element-149">Laser treatments: £750-£2,625 per session</li>
              <li data-id="element-150">Chemical peels: £115-£300 monthly</li>
              <li data-id="element-151">Prescription retinoids: £60-£190 monthly</li>
            </ul>
            <p className="font-bold text-gray-800" data-id="element-152">
              Total annual cost: £3,600-11,250+
            </p>
          </div>
          <p className="text-gray-700 mb-4" data-id="element-153">
            But here's the dirty secret: None of these treatments address what's
            causing many of your wrinkles in the first place.
          </p>
        </div>
        <div className="md:w-1/2 flex items-center justify-center" data-id="element-154">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aL884qgbac2QE1jgFisxCg/nonono.png" alt="Anti-aging treatments that don't address the root cause" className="rounded-lg shadow-lg max-w-full w-4/5" data-id="element-155" />
        </div>
      </div>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-156">
        "I was essentially putting a band-aid on a wound that was being reopened
        every single night," Dr. Grant explains. "My patients would get Botox,
        look amazing for 3 months, then come back with the same lines in the
        same places. It was like helping someone bail water out of a boat that
        had a hole in it."
      </blockquote>
      <h3 className="text-xl font-bold text-blue-900 mb-3" data-id="element-157">
        The Financial Incentive to Keep You Aging
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-158">
        Dr. Grant's financial realisation was brutal:
      </p>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-159">
        "A patient who solves their aging problem with a £59 one-time purchase
        generates £59. A patient trapped in the treatment cycle generates up to
        £37,500+ over 10 years."
      </blockquote>
      <p className="text-gray-700 mb-4" data-id="element-160">
        The math is simple. Prevention doesn't pay the bills.
      </p>
      <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-161">
        "Medical school teaches us to 'first, do no harm,'" Dr. Grant says. "But
        business school teaches practice owners to maximize lifetime customer
        value. Guess which lesson wins when you have a £1.5 million practice
        loan to pay off?"
      </blockquote>
    </section>;
};